<template>
  <div class="c-brief-apply" v-for="article of articles" :key="article.uuid">
    <div class="c-brief-apply__dashed-line">
      <divide dashed mt="40" mb="40" />
    </div>

    <div class="brief">
      <div
        class="brief__img"
        :style="{ 'background-image': `url(${coverImageSrc(article.cover_path)})` }"
        @click="toPage(article.user_type, article.uuid)"
      ></div>

      <div class="brief__info">
        <p class="brief__info__title" @click="toPage(article.user_type, article.uuid)">{{ article.title }}</p>

        <p class="brief__info__date-type">
          <span class="brief__info__date-type__date">{{ article.published }}</span>
          <span class="brief__info__date-type__type">{{ identificationMapping[String(article.user_type)] }}</span>
          <span
            class="brief__info__date-type__status"
            :class="{
              'brief__info__date-type__status--notOpenYet': applyStatusType(article) === 'notOpenYet',
              'brief__info__date-type__status--registered': applyStatusType(article) === 'registered',
              'brief__info__date-type__status--expired': applyStatusType(article) === 'expired',
              'brief__info__date-type__status--full': applyStatusType(article) === 'full',
              'brief__info__date-type__status--available': applyStatusType(article) === 'available',
            }"
          >
            {{statusMapping[applyStatusType(article)]}}
          </span>
        </p>
        <p class="brief__info__desc">
          {{ article.description }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, computed } from 'vue';
// import { useRouter } from 'vue-router';
import { useRouter } from 'vue-router';
import dayjs from 'dayjs';
import Divide from '@/components/Global/Divide.vue';
import articleMapping from '@/config/articleMapping';
import { identificationMapping } from '@/config/identificaitionConfig';
import { statusMapping, applyStatusType } from '@/config/applyStatus';
import previewImg from '@/assets/img/global/img_preview.jpg';

export default defineComponent({
  name: 'PrApplyBrief',
  components: {
    Divide,
  },
  props: {
    articles: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'story',
    },
  },
  setup(props) {
    const router = useRouter();

    const toPage = (userType, id) => {
      router.push({
        // name: userType === 1 ? 'activity-lesson-parent-apply' : 'activity-lesson-team-apply',
        name: 'activity-lesson',
        query: { id },
      });
    };

    const formatHtml = computed(() => props.articles.map((a) => {
      try {
        a.content = `${a.content.replace(new RegExp('<[^>]*>', 'g'), '').substr(0, 100)}...`;
        a.published = dayjs(a.published).format('YYYY-MM-DD');

        return a;
      } catch {
        return a;
      }
    }));

    const baseUrl = process?.env?.VUE_APP_BASE_URL || window.location.host;
    const coverImageSrc = (path) => (path ? `${baseUrl}/${path}` : previewImg);

    // const applyStatusType = (data) => {
    //   if (dayjs().isBefore(dayjs(data.apply_start_date))) {
    //     return 'notOpenYet';
    //   }

    //   if (dayjs(data.apply_end_date).isBefore(dayjs())) {
    //     return 'expired';
    //   }

    //   console.log(data.apply_limit, data.apply_count);

    //   return data.apply_limit <= data.apply_count ? 'full' : 'available';
    // };

    return {
      articleMapping,
      identificationMapping,
      toPage,
      formatHtml,
      coverImageSrc,
      applyStatusType,
      statusMapping,
    };
  },
});
</script>
<style lang="scss" scoped>
.c-brief-apply {
  &__dashed-line {
    display: none;
  }

  & + & {
    .c-brief-apply__dashed-line {
      display: block;
    }
  }
}

.brief {
  width: 100%;

  &__img {
    width: 100%;
    height: calc(90vw * 0.66);
    border-radius: 20px;
    overflow: hidden;
    flex: none;
    cursor: pointer;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  &__info {
    // @include flex();
    flex: 1;
    margin-top: 15px;

    &__title {
      @include font-important();
      cursor: pointer;
    }

    &__date-type {
      &__date {
        @include font-normal(rgba($c-main, 0.5));
      }

      &__type {
        @include font-style($c-main-pink, 16, 400, 1.6px, 28px);
        margin-left: 26px;
        position: relative;

        &::before {
          content: '';
          width: 1px;
          height: 24px;
          display: inline-block;
          background-color: rgba($c-main, 0.5);

          @include position(tl, 50%, -13px);
          transform: translateY(-50%);
        }
      }

      &__status {
        @include font-style($c-assist-green, 16, 400, 1.6px, 28px);
        margin-left: 26px;
        position: relative;

        &--notOpenYet {
          color: rgba($c-main-yellow, 0.8);
        }

        &--expired {
          color: rgba($c-grey, 0.5);
        }

        &--full {
          color: rgba($c-red, 0.5);
        }

        &--available {
          color: $c-assist-green;
        }

    &--registered {
      color: rgba($c-main-yellow, 0.8);
    }

        &::before {
          content: '';
          width: 1px;
          height: 24px;
          display: inline-block;
          background-color: rgba($c-main, 0.5);
          @include position(tl, 50%, -13px);
          transform: translateY(-50%);
        }
      }
    }

    &__desc {
      @include font-normal();
    }
  }
}

@media screen and (min-width: $tablet) {
  .brief {
    @include flex(flex-start, flex-start);

    &__img {
      width: 260px;
      height: 172px;
    }

    &__info {
      margin-left: 40px;
      margin-top: 0;
    }
  }
}
</style>
